module.exports = __webpack_public_path__ + "img/TKL.fa96c069.svg";